import { MaskIcon } from "@/components/icon/MaskIcon.tsx";
import { getOwn } from "@warrenio/utils/collections/getOwnProperty";

const osIcons: Record<string, string> = {
    linux: "jp-linux-icon",
    windows: "jp-windows-icon",
    multi: "jp-web-icon",
};

export function HvOs({ value }: { value: string }) {
    return (
        <div className="HStack gap-1">
            <HvOsIcon value={value} className="color-muted size-0.875rem" />
            {value}
        </div>
    );
}

export function HvOsIcon({ value, className }: { value: string; className?: string }) {
    const icon = getOwn(osIcons, value);
    return icon ? <MaskIcon className={`${icon} ${className}`} /> : null;
}
